import profile from "../assets/images/profile.svg";
import {ReactComponent as logo} from "../assets/images/CabLinks.svg";
export const Appimg ={
  profile:profile,
  Logo:logo
}